import { CircularProgress } from '@heroui/react';

/** Maps a 0-100 percentage to a semantic color by threshold. */
function colorFor(percent: number): 'success' | 'warning' | 'danger' {
  if (percent >= 90) return 'danger';
  if (percent >= 75) return 'warning';
  return 'success';
}

interface UsageGaugeProps {
  /** 0-100. */
  percent: number;
  /** Caption under the gauge (e.g. "3.2 GB of 10 GB"). */
  caption?: string;
  label?: string;
}

/** Circular usage gauge with threshold coloring — used by Storage/CPU/Memory. */
export function UsageGauge({ percent, caption, label }: UsageGaugeProps) {
  const clamped = Math.max(0, Math.min(100, Math.round(percent)));
  return (
    <div className="flex flex-col items-center justify-center gap-1 py-1">
      <CircularProgress
        aria-label={label ?? 'Usage'}
        value={clamped}
        color={colorFor(clamped)}
        showValueLabel
        size="lg"
        classNames={{ svg: 'h-24 w-24', value: 'text-lg font-semibold text-fg' }}
      />
      {caption && <p className="text-center text-xs text-fg-subtle">{caption}</p>}
    </div>
  );
}
